var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { BellIcon, Fade, Notification, TypographyBody } from '@honeycomb/ui-core';
export function NightsAdjustedNotification(_a) {
    var { message } = _a, other = __rest(_a, ["message"]);
    const [open, setOpen] = useState(true);
    const [exited, setExited] = useState(false); // Track when the fade animation has completed.
    const { resourceStrings: { EXTENDEDFLIGHTSELECTIONNIGHTSNOTIFICATIONTEXT }, } = useGlobalContext();
    if (!open && exited) {
        return null;
    }
    return (React.createElement(Fade, { in: open, onExited: () => {
            setExited(true);
        } },
        React.createElement(Notification, Object.assign({ "data-id": "night_adjusted_notification", color: "info", onDismiss: () => {
                setOpen(false);
            }, icon: React.createElement(BellIcon, null) }, other),
            React.createElement(TypographyBody, null, message !== null && message !== void 0 ? message : EXTENDEDFLIGHTSELECTIONNIGHTSNOTIFICATIONTEXT))));
}
